<template>
    <div>
        <h1>Ketone</h1>
        <p>
            Ketone sind organische Stoffe, die bei der Oxidation von
            <router-link to="alkohole">Alkoholen</router-link> (Sekundärer
            Alkohol) entstehen. Wichtig ist dabei, dass die C=O-Verbindung nicht
            an einem der endständigen C-Atomen ist. Sie bestehen aus einer
            üblichen Kohlenwasserstoffkette und einem C-Atom, mit einer
            Doppelbindung zu einem O-Atom, sowie zwei benachbarten C-Atomen. Die
            C=O-Doppelbindung ist sehr polar, Wasserstoffbrücken bilden sich
            aber erst bei der Lösung in Wasser (da sonst kein
            sauerstoffgebundenes H-Atom vorhanden ist).
        </p>
        <img
            src="@/assets/img/stoffe/ketone/allgemeine-struktur.png"
            alt="Allgemeine Struktur der Ketone"
            title="Allgemeine Struktur der Ketone"
            width="128px"
            height="auto"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Reaktionen"></chapter-heading>
        <ul>
            <li>
                Oxidation eines sekundären
                <router-link to="alkohole">Alkohols</router-link> => Ketone
            </li>
            <li>
                Keine weitere Oxidation von Ketonen!
            </li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>
                            bestehen aus, C-Atomen, H-Atomen und einer
                            <router-link to="/gruppen/carbonyl"
                                >Carbonylgruppe</router-link
                            >
                        </li>
                        <li>
                            besitzen nur Einfachbindungen und eine
                            C=O-Doppelbindung
                        </li>
                        <li>
                            entstehen aus der Oxidation sekundärer
                            <router-link to="alkohole">Alkohole</router-link>
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Allgemeine Benennung</th>
                <td>n-<em>Alkan</em>on</td>
            </tr>
            <tr>
                <th>Eigenschaften</th>
                <td>
                    <ul>
                        <li>Dipol-Dipol-Kräfte</li>
                        <li>Wasserstoffbrücken nur in Lösung</li>
                        <li>
                            gut Wasserlöslich (nimmt mit zunehmender C-Kette ab)
                        </li>
                    </ul>
                </td>
            </tr>
            <tr>
                <th>Bindungen</th>
                <td>Kohlenwasserstoffkette mit <b>nicht-</b>endständige C=O</td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
